<div class="manage-subscription-modal">

  <div class="container-close-button" (click)="onClose()">
    <img ngSrc="/assets/images/icons/cross.svg" alt="Icon cross" height="24" width="24">
  </div>

  <app-shared-modal-header
    [title]="'Modifier le matériel de la communauté'"
    [subtitle]="'Veuillez remplir le formulaire ci-dessous pour modifier le matériel'"
    iconName="hardware"
    [isDeleteModal]="false">
  </app-shared-modal-header>

  <div class="container-modal-form">
    <div class="container-error-block" *ngIf="error">
      {{ error.code | translate }}
    </div>
    <app-hardware-form #hardwareFormComponent
      [formGroupForm]="hardwareForm">
    </app-hardware-form>
  </div>

  <div class="container-modal-actions">
    <button mat-stroked-button (click)="onClose()"
            class="full-width base"
            type="button">
      <div class="icon">
        Annuler
      </div>
    </button>
    <button mat-flat-button (click)="submit()"
            class="full-width"
            color="accent"
            type="button"
            [disabled]="!hardwareForm.valid || isLoading">
      <div *ngIf="!isLoading">Valider</div>
      <div *ngIf="isLoading">
        <mat-spinner [diameter]="24"></mat-spinner>
      </div>
    </button>
  </div>

</div>
